<template>
    <div>
        <!-- 전체보기 선택 시 보여주기
            <product-cards></product-cards>
        -->
        <!-- 선물하기 선택 시 보여주기
            <present></present>
        -->
      <div class="product-detail-wrap">
        <subject-text class="subject-text card-pick-padding" text=""></subject-text>
<!--        <subject-text class="subject-text card-pick-padding" text="카드선택"></subject-text>-->
<!--        24-01-25 구매하기,선물하기 모두 카드 이미지 목록을 받아서 선택할 수 있도록 요건 변경-->
        <!--        <emarticon-card-buy v-if="orderType === 'BUY'" :slide-data="card" :orderType="orderType" type="select"></emarticon-card-buy>-->
        <emarticon-card-buy ref="cardSlide" v-if="imageDataReady"
                            :slide-data="cardList"
                            :imageCategory="cardCategoryList"
                            :orderType="orderType"
                            :imageNo="prepaidCardOrderRequest.imageNo"
                            type="select"
                            classname="product-detail-slide"
                            @selectedCardImageNo="selectedCardImageNo"
                            @useCardImageModal="useCardImageModal"
        ></emarticon-card-buy>
      </div>
      <div class="px-20 mb-32">
          <div class="save-box" v-if="calcAmountNotice !== '' ">
            <span class="add-text">{{ calcAmountNotice }}되는 상품입니다.</span>
          </div>
        <div v-if="orderType === 'BUY'">
          <subject-text class="subject-text card-pick-padding" text="카드명(별칭) 입력"></subject-text>
          <input ref="nickName" class="input-base" type="text" placeholder="카드명(카드 식별용 별칭)" title="카드명(카드 식별용 별칭)"
                 :value="prepaidCardOrderRequest.prepaidCardNickName"
                 @keyup="checkValidity('nickName')"
                 @input="nickNameBind"/>
          <div ref="nickNameAlertBox" style="margin-left: auto; display:none">
            <img src="@/assets/images/icon-alert.png" style="margin-right: 1px" alt="카드명 입력 확인 알림">
            <span ref="nickNameAlertMessage" class="alertMessageBox"></span>
          </div>
        </div>
      </div>
        <gray-line></gray-line>
        <div class="px-20 mt-32">
          <subject-text class="subject-text card-pick-padding" text="구매자 전화번호 입력"></subject-text>
          <input ref="phoneNumber" class="input-base" type="text" placeholder="휴대폰 번호 (필수, 숫자만 입력)" title="휴대폰 번호"
                 :value="phoneNumber"
                 @input="phoneNumberBind"
                 @keyup="[setDash($event, false),checkValidity('phoneNumber')]"
                 maxlength="13"/>
          <div ref="phoneNumberAlertBox" style="margin-left: auto; display:none">
            <img src="@/assets/images/icon-alert.png" style="margin-right: 1px" alt="핸드폰 번호 입력 확인 알림">
            <span ref="phoneNumberAlertMessage" class="alertMessageBox"></span>
          </div>
          <div class="mb-20 mt-12">
            <em class="em-text">∙ 구매하시는 분의 휴대폰 번호를 입력하시고<br/>&nbsp;&nbsp;입력하신 번호가 맞는지 꼭 확인해주세요.</em>
          </div>
        </div>
      <div v-if="orderType === 'GIFT'">
        <gray-line></gray-line>
        <div class="px-20 mt-20">
          <subject-text class="subject-text card-pick-padding" text="선물 받는 분 정보 입력"></subject-text>
          <input ref="receiverName" type="text" class="input-base" placeholder="이름 (필수)" title="이름"
                 :value="giftRequestInfo.receiverName"
                 @keyup="checkValidity('receiverName')"
                 @input="receiverNameBind"/>
          <input ref="receiverPhoneNumber" type="text" class="input-base" title="휴대폰번호"
                 style="margin-top: 0.5rem;"
                 placeholder="휴대폰번호 (필수)"
                 :value="giftRequestInfo.receiverPhoneNumber"
                 @input="receiverPhoneNumberBind"
                 @keyup="[setDash($event, true),checkValidity('receiverPhoneNumber')]"
                 maxlength="13"/>
          <div ref="receiverAlertBox" style="margin-left: auto; display:none">
            <img src="@/assets/images/icon-alert.png" style="margin-right: 1px" alt="선물받는 분 정보 입력 확인 알림">
            <span ref="receiverAlertMessage" class="alertMessageBox"></span>
          </div>
          <div class="mb-20 mt-12">
            <span class="dot"></span>
            <em class="em-text">받는 분의 이름과 휴대폰 번호를 정확히 입력해주세요.</em>
          </div>
        </div>
        <gray-line></gray-line>
        <div class="px-20 mt-20">
          <subject-text class="subject-text card-pick-padding" text="선물 메세지 입력"></subject-text>
          <div class="text-box">
            <textarea cols="50" maxlength="100" placeholder="감사한 마음을 담아 선물을 드립니다." title="선물 메세지 입력"
                      v-model="giftRequestInfo.giftMessage"
            />
            <span>({{giftMessageCount}}/100)</span>
          </div>
          <div ref="giftMessageAlertBox" style="margin-left:auto; display:none;">
            <span ref="giftMessageAlertMessage" style="font-size:14px; color:green;">선물메세지는 최대 100자 입니다.</span>
          </div>
          <div class="mb-32 mt-12"></div>
        </div>
      </div>
      <gray-line></gray-line>
      <div id="payment-method"></div>
      <gray-line></gray-line>
      <div>
        <div class="result-pay">
            <strong>최종 결제금액</strong>
            <span>{{ goodsAmount }}</span>
        </div>
        <div class="bottom-gray-line"></div>
        <div  v-if="calcAmountNotice !== '' ">
            <div class="add-save">
                <span>{{ calcAmountNotice }}</span>
                <em>{{ calcAmount }}원</em>
            </div>
            <div class="benefit">
                <div>
                    <strong>최종 혜택금액</strong>
                    <span>{{ benefitAmount }}</span>
                </div>
            </div>
        </div>
      </div>
      <gray-line></gray-line>
      <product-detail-buy-list></product-detail-buy-list>
      <gray-line></gray-line>
      <div class="pt-44 pb-32 px-20">
        <div class="flex-y-center radio-wrap mb-32">
          <label class="radiobox">
            <input type="checkbox" class="normal-radio icon-round-check" name="normalcharging"
                   @click="checkAllTerms"
                   v-model="isAgreeAll"
            />
            <span>전체 동의</span>
          </label>
        </div>
        <div class="flex-y-center radio-wrap">
          <label class="radiobox">
            <input type="checkbox" ref="termsOfOrder" class="normal-radio icon-round-check" name="normalcharging"
                   @click="[checkTermsOfOrder($event),checkValidity('termsOfOrder')]"
                   v-model="isOrderAgree"
            />
            <span>주문할 상품정보에 동의 하십니까?(필수)</span>
          </label>
        </div>
        <div ref="termsOrderAlertBox" id="termsOrderAlertBox" style="margin-left: auto; visibility:hidden">
          <img src="@/assets/images/icon-alert.png" style="margin-right: 1px" alt="주문 상품정보 동의 필수">
          <span ref="termsOrderAlertMessage" class="termsAlertMessageBox">주문할 상품정보 동의는 필수입니다.</span>
        </div>
        <div class="terms-gray-box" style="margin-top:0 !important; margin-bottom: 1.5rem;">
          <span>전자상거래법 제 8조 2항</span>
          <button @click="showAgreePopupEvent('termsOfCommercial')">보기</button>
        </div>
        <div class="flex-y-center radio-wrap">
          <label class="radiobox">
            <input type="checkbox" ref="termsOfUse" class="normal-radio icon-round-check" name="normalcharging"
                   @click="[checkTermsOfUse($event),checkValidity('termsOfUse')]"
                   v-model="isAgree"
                   />
            <span>서비스 이용 동의(필수)</span>
          </label>
        </div>
        <div ref="termsAlertBox" id="termsAlertBox" style="margin-left: auto; visibility:hidden">
          <img src="@/assets/images/icon-alert.png" style="margin-right: 1px" alt="서비스 이용 동의 필수">
          <span ref="termsAlertMessage" class="termsAlertMessageBox">서비스 이용 동의는 필수입니다.</span>
        </div>
        <div class="terms-gray-box" style="margin-top:0 !important; margin-bottom: 1.5rem;">
          <span>서비스 이용약관</span>
          <button @click="showAgreePopupEvent('termsOfUse')">보기</button>
        </div>
        <div class="flex-y-center radio-wrap">
          <label class="radiobox">
<!--            <input type="checkbox" ref="termsOfPrivate" class="normal-radio icon-round-check" name="normalcharging"-->
<!--                   @click="[checkTermsOfPrivate($event),checkValidity('termsOfPrivate')]"-->
<!--                   v-model="isPrivateAgree"-->
<!--            />-->
            <span>개인정보 수집/이용 안내</span>
          </label>
        </div>
        <div ref="termsPrivateAlertBox" id="termsPrivateAlertBox" style="margin-left: auto; visibility:hidden">
          <img src="@/assets/images/icon-alert.png" style="margin-right: 1px" alt="개인정보 수집 동의 필수">
          <span ref="termsAlertMessage" class="termsAlertMessageBox"></span>
        </div>
<!--        <div class="terms-productdetail-box" style="margin-top:0 !important">-->
<!--          <span>∙ 개인정보 관련 자세한 사항은 이마트 홈페이지(<a style="text-decoration: underline;" href="https://www.emart.com">www.emart.com</a>)-->
<!--            <a style="color: red;text-decoration: underline;" href="https://eapp.emart.com/member/personal_info.do">개인정보처리방침</a>에서 확인 가능합니다.</span>-->
<!--&lt;!&ndash;          <button @click="showAgreePopupEvent('termsOfPrivateInfo')">보기</button>&ndash;&gt;-->
<!--        </div>-->
        <div class="terms-gray-box" style="margin-top:0 !important; margin-bottom: 1.5rem;">
          <span>개인정보 수집/이용 안내</span>
          <button @click="showAgreePopupEvent('termsOfPrivateInfo')">보기</button>
        </div>
      </div>
      <gray-line></gray-line>
      <div class="emarticon-precautions">
        <div>
            <span class="icon-tool-tip"></span>
            <strong>이마티콘 유의사항</strong>
        </div>
        <ul>
            <li>
                <p>∙ 통신사나 휴대폰 사정 등 당사의 귀책사유가 없는 미수신의 경우에 대하여 당사는 책임지지 않습니다.</p>
            </li>
            <li>
                <p>∙ 당사의 귀책사유 없이 수신자가 잘못 선택된 경우에는 수신자가 그로 인한 책임을 부담하게 되오니 유의하시기 바랍니다.</p>
            </li>
            <li>
                <p>∙ 번호도용 문자차단/휴대폰번호 도용방지 서비스에 가입된 휴대폰은 발송 또는 수신이 불가합니다. (부가서비스 해지 후 반영까지 약 24시간 소요됩니다.)</p>
            </li>
            <li>
                <p>∙ 휴대폰 번호로 전송하시는 경우 발송 환경에 따라 수신완료까지 최대 3시간이 소요될 수 있습니다.</p>
            </li>
            <li>
                <p>∙ 결제 취소는 수신자가 이마티콘을 등록하지 않고, 사용 이력이 없는 경우 온라인에서 구매/충전 취소가 가능합니다.</p>
            </li>
            <li v-if="setPrecautionsEnable()">
              <p>∙ 이마티콘은 월 최대 500만원 구매 가능합니다.<br>
                (구매/선물/충전/자동충전 합산액 기준)<br>
                매월 1일에 구매 가능 한도가 자동 복원됩니다.</p>
            </li>
        </ul>
      </div>
      <div class="button-wrap bottom-sticky" style="z-index: 2">
        <button ref="buyButton" v-if="orderType === 'BUY'" :disabled="isButtonDisabled" @click="clickPaymentButton('ISSUE',null)" class="bottom-sticky button-bg-gray">구매하기</button>
        <button ref="giftButton" v-if="orderType === 'GIFT'" :disabled="isButtonDisabled" @click="clickPaymentButton('GIFT', giftRequestInfo)" class="bottom-sticky button-bg-gray">선물하기</button>
        <phone-number-confirm-popup v-if="confirmModal" @phoneNumberConfirm="receiverPhoneNumberConfirm"/>
        <gift-to-me-popup v-if="giftToMeModal" @giftToMeConfirm="giftToMeConfirm"></gift-to-me-popup>
        <card-all v-if="cardImageModal"
                  @getImageNo="selectedCategoryImageNo"
                  @useCardImageModal="useCardImageModal"
                  :imageCategory="cardCategoryList"
                  :cardList="cardList" >

        </card-all>
      </div>

      <agree-popup v-if="showAgreePopup === true" @close="showAgreePopup = false" :terms="showTerms"></agree-popup>
    </div>
</template>
<script>
import TopHeader from '@/components/layout/Header.vue';
import SubjectText from '@/components/common/SubjectText.vue';
import GrayLine from '@/components/common/GrayLine.vue';
import BottomButton from '@/components/common/BottomButton.vue';
import ProductCards from '@/components/common/ProductCards.vue';
import Present from '@/components/common/Present.vue';
import axios from 'axios';
import EmarticonCardBuy from "@/components/common/EmarticonCardBuy";
import PhoneNumberConfirmPopup from "@/views/products/phoneNumberConfirmPopup";
import giftToMePopup from "@/views/products/giftToMePopup";
import apiList from "@/api/apiList";
import CardAll from "@/views/products/cardAll";
import ProductDetailBuyList from "@/components/common/ProductDetailBuyList";
import AgreePopup from "@/views/products/AgreePopup.vue";

let paymentWidget = '';
let widget = '';
export default {
  name: 'ProductDetail',
  components: {
    AgreePopup,
    PhoneNumberConfirmPopup, TopHeader,
    EmarticonCardBuy, SubjectText, GrayLine, BottomButton, ProductCards, Present, CardAll, giftToMePopup,
    ProductDetailBuyList},
  props: {
    goodsDetail: Object
  },
    data(){
      return{
        /** @type {Array} swiper의 props(slide-data) (구매하기)*/
        card: [{id : '', cardImg : ''}],
        /** @type {Array} swiper의 props(slide-data) (선물하기)*/
        cardList: [],
        /** @type {Array} 카드 이미지 카테고리 */
        cardCategoryList: [],
        bgName: ['cake-center'],
        /** @type {String} 결제위젯 연동 키, 고유한 값으로 고정 값이다. 외부에 유출되면 안되는 정보. */
        clientKey: process.env.VUE_APP_TOSS_CLIENT_KEY,
        /** @type {String} 사용자별 고유한 id여야 한다. */
        customerKey : this.$store.state.mberInfo.mberNo,
        /** @type {Object} 할인 종류 ENUM 객체 */
        discountType : {
          /** @type {String} 정률 할인 */
          FIXED_RATE_DISCOUNT : '% 할인',
          /** @type {String} 정액 할인 */
          FLAT_DISCOUNT : '원 할인',
          /** @type {String} 정률 추가 충전 */
          FIXED_RATE_EXTRA_CHARGE : '% 추가충전',
          /** @type {String} 정액 추가 충전 */
          FLAT_EXTRA_CHARGE : '원 추가충전',
        },

        /** @type {Object} 주문서 생성 요청 객체 */
        prepaidCardOrderRequest :  {
          /** @type {String} 고객사 번호 */
          ctmmnyNo : '',
          /** @type {String} 회원 번호 */
          mberNo : '',
          /** @type {String} 결제 요청자 */
          paymentRequester : '',
          /** @type {String} 결제 요청자 연락처, 01033331111 양식으로 보낸다 */
          paymentRequesterContact : '',
          /** @type {String} 카드 이름 */
          prepaidCardNickName :'',
          /** @type {String} 결제수단코드 */
          payToolCode : '',
          /** @type {String} PG코드 */
          pgCode : '',
          /** @type {Number} 원 결제금액 */
          originalAmount : 0,
          /** @type {Number} 실 결제금액 */
          paymentAmount : 0,
          /** @type {String} 선불카드 상품 번호 */
          goodsNo : '',
          /** @type {Number} 이미지번호 */
          imageNo : '',
          /** @type {String} 결제사유
           *    ISSUE,      발급
           *     GIFT,       선불카드 선물
              *     ISSUE_VOID,    발급 취소
              *     GIFT_VOID,       선불카드 선물 취소
              *     RELOAD,      충전
              *     RELOAD_VOID    충전 취소
           */
          paymentReason : '',
          /** @type {String} 요청 채널
           *  - ONLINE: WEB/APP등 고객이 직접 신청하는 경우 - REALTIME (실시간 발급)
           *  - ADMIN: 관리자 요청 - MANUAL (매뉴얼 발급)
           *  - BATCH: 배치 - MASS (대량 발급)
           *  - EXTERNAL: 외부 요청 - EXTERNAL(외부 발급)
           * */
          requestChannel : '',
          /** @type {String} 선물 받는 분의 이름 */
          receiver : '',
          /** @type {String} 선물 받는 분의 핸드폰 번호 */
          receiverContact : '',
          /** @type {String} 선물메세지 */
          giftMessage : '',
          /** @type {String} 요청자 ID */
          requestId : '',
          /** @type {String} 혜택번호 */
          benefitNo: '',
        },
        /** @type {Object}  선물요청정보 객체 */
        giftRequestInfo : {
          /** @type {String} 선물 받는 분의 이름 */
          receiverName : '',
          /** @type {String} 선물 받는 분의 핸드폰 번호 */
          receiverPhoneNumber : '',
          /** @type {String} 선물메세지 */
          giftMessage : '',
        },
        /** @type {Number} 선물메세지 글자수 */
        giftMessageLength : 0,
        /** @type {String} 주문 타입
         *  - BUY : 구매
         *  - GIFT : 선물
         * */
        orderType : '',
        /** @type {String} 주문 번호 */
        orderId : '',
        /** @type {String} 주문 명 */
        orderName : '',
        /** @type {String} 상품 이미지 */
        goodsImageUrl : '',
        /** @type {Boolean} 전체 동의 값 */
        isAgreeAll : false,
        /** @type {Boolean} 주문 상품정보 동의 값 */
        isOrderAgree: false,
        /** @type {Boolean} 개인정보 수집 동의 값 */
        // isPrivateAgree: false,
        /** @type {Boolean} 이용약관 동의 값 */
        isAgree: false,
        /** @type {Number} 최종결제금액 */
        goodsAmount: 0,
        /** @type {Number} 할인금액 */
        calcAmount: 0,
        /** @type {String} 할인혜택문구("1,000원 추가적립", "10% 추가적립") */
        calcAmountNotice: '',
        /** @type {Number} 혜택금액(결제금액+할인금액) */
        benefitAmount: 0,
        /** @type {String} 구매자 연락처 */
        phoneNumber: '',
        /** @type {Boolean}  선물받는분의 핸드폰 번호 확인여부 */
        confirmReceiverPhoneNumber: false,
        /** @type {Boolean}  나에게 선물하기 동의 하는지 확인여부 */
        confirmGiftToMe: false,
        /** @type {Boolean} 핸드폰 번호 확인 컨펌 모달 */
        confirmModal: false,
        /** @type {Boolean} 구매자 번호, 선물받는 분 번호 동일 알림 모달 */
        giftToMeModal: false,
        /** @type {Boolean} 카드 이미지 선택 모달 */
        cardImageModal : false,
        /** @type {Boolean} 구매 버튼 disabled 여부 */
        isButtonDisabled : false,
        /** @type {Object} 유효성 전체 관리 Object */
        validationObject: {
          nickName : false,
          phoneNumber : false,
          receiverName : false,
          receiverPhoneNumber : false,
          termsOfUse : false,
          termsOfOrder : false,
          // termsOfPrivate : false,
        },
        /** @type {Object} 상품정보 단건 조회 요청 객체(혜택가 등의 계산을 위해 단순히 상품정보만 가져와서는 안된다) */
        prepaidCardGoodsRequest: {
          goodsNo: '',
          benefitNo: ''
        },
        /** @type {Boolean} 자신에게 선물 여부 */
        giftToMe : false,
        /** @type {Boolean} 이미지 데이터 준비 여부 */
        /** 이미지 데이터와 이미지 카테고리 데이터가 준비되지 않은 상태에서 자식창(EmarticonCardBuy)에서 props로 바인딩된 데이터를 조작하려고 하면 undefined 오류 발생함*/
        imageDataReady : false,
        showAgreePopup: false,  //이용약관 팝업 보여주기 여부
        showTerms:'', //이용약관
      }

    },
  watch : {
    /**
     * validationObject 의 값의 변화를 감지합니다.
     * 구매하기(선물하기)의 조건 만족여부에 따라 구매하기(선물하기) 버튼을 활성화 혹은 비활성화
     */
    validationObject: {
      /**
       * watch 내부에서 제공하는 함수
       * @param newValue 변화가 일어난 후의 validationObject 값
       * (당장은 handler를 반드시 활용할 필요는 없으나 후에 oldValue를 사용할 가능성에 대비하여 handler를 사용)
       * handler(newValue, oldValue)와 같이 사용 가능함. (변화 후의 validationObject, 변화 전의 validationObject)
       */
      handler(newValue) {
        if('BUY' === this.orderType){
          let allPass = newValue.nickName && newValue.phoneNumber && newValue.termsOfUse && newValue.termsOfOrder;
          if(allPass){
            //구매버튼 활성화
            this.$refs.buyButton.classList.remove('button-bg-gray');
            this.$refs.buyButton.classList.add('button-bg-yellow');
          } else {
            //구매버튼 비활성화
            this.$refs.buyButton.classList.remove('button-bg-yellow');
            this.$refs.buyButton.classList.add('button-bg-gray');
          }
        }

        if('GIFT' === this.orderType){
          // 선물하기는 nickName 조건 패스
          this.validationObject.nickName = true;
          let isPass = true;
          Object.values(newValue).forEach(value => {
            if(!value){
              isPass = false;
              //구매버튼 비활성화
              this.$refs.giftButton.classList.remove('button-bg-yellow');
              this.$refs.giftButton.classList.add('button-bg-gray');
            }
          })
          if(isPass){
            //구매버튼 활성화
            this.$refs.giftButton.classList.remove('button-bg-gray');
            this.$refs.giftButton.classList.add('button-bg-yellow');
          }
        }
      },
      deep: true,
    },
    /**
     * 선물받는 분의 핸드폰번호 값을 감지하고 구매자의 핸드본 번호와 선물받는 분의 핸드폰 번호가 같으면 giftToMe 값을 변경
     */
    giftRequestInfo :{
      handler(newValue) {
        if('GIFT' === this.orderType){
          this.giftToMe = newValue.receiverPhoneNumber === this.phoneNumber;
        }
      },
      deep: true
    },
    /**
     * 구매자 핸드폰번호 값을 감지하고 구매자의 핸드본 번호와 선물받는 분의 핸드폰 번호가 같으면 giftToMe 값을 변경
     * 2025.09.22 구매자 핸드폰번호를 변경하면 체크하지 못하는 이슈가 발견되어 해당 로직 추가
     */
    phoneNumber :{
      handler() {
        if('GIFT' === this.orderType){
          this.giftToMe = this.giftRequestInfo.receiverPhoneNumber === this.phoneNumber;
        }
      },
      deep: true
    },
    /** 주문 상품정보 동의 값 감시 */
    isOrderAgree(){
      this.checkAgreeAll();
    },
    /** 개인정보 수집 동의 값 감시 */
    // isPrivateAgree(){
    //   this.checkAgreeAll();
    // },
    /** 이용약관 동의 값 감시 */
    isAgree(){
      this.checkAgreeAll();
    },


  },
  mounted() {
    // Netfunnel 버전 업그레이드로 현재 사용 버전 제거 - 추후 업그레이드 버전으로 작업 예정
    // NetFunnel_Complete();

    paymentWidget = PaymentWidget(this.clientKey, this.customerKey, {
      // 결제위젯에 브랜드페이 추가하기
      brandpay: {
        // Access Token 발급에 사용되는 리다이렉트 URL
        redirectUrl: `${process.env.VUE_APP_BACK_BASE_URL}/v1.0.0/prepaid-card/redirect-url`
      }
    })

    // 구매 타입(BUY: 구매, GIFT: 선물)
    if(this.$route.query.orderType === 'GIFT') {
      this.$heading('선물하기');
    } else {
      this.$heading('구매하기');
    }

    // 상품 상세 정보를 조회 후 값을 세팅
    this.setGoodsDetail();

    this.isButtonDisabled = false

    this.$refs.termsOfOrder.checked = false;
    // this.$refs.termsOfPrivate.checked = false;
    this.$refs.termsOfUse.checked = false;

  },
  computed:{
    /**
     * 선물글자수를 체크하고 data에 바인딩하는 함수
     */
    giftMessageCount(){
      if(this.$refs.giftMessageAlertBox) {
        if(this.giftRequestInfo.giftMessage.length >= 100){
          this.giftRequestInfo.giftMessage.substring(0, 100); //100자 자르기
          this.$refs.giftMessageAlertBox.style.display= 'block'
        } else {
          this.$refs.giftMessageAlertBox.style.display= 'none'
        }
      }
      return this.giftRequestInfo.giftMessage.length
    },
  },
  methods: {
    /**
     * 메인페이지에서 받은 상품 상세 정보를 바인딩하는 함수
     */
    async getGoodsParams(){
      this.prepaidCardGoodsRequest.goodsNo = this.$route.query.goodsInfo;
      this.prepaidCardGoodsRequest.benefitNo = this.$route.query.benefitNo;
      const res = await apiList.getPrepaidCardGoodsInfoAndBenefit(this.prepaidCardGoodsRequest);
      const goodsInfo = res.data.data;

      if(!goodsInfo){
        const errorPath = '/error'

        if (this.$route.path !== errorPath) {
          this.goErrorPage();
        }
        return;
      }
      // 구매 타입(BUY: 구매, GIFT: 선물)
      this.orderType = this.$route.query.orderType;
      // 주문 명
      this.orderName = goodsInfo.goodsName;
      //상품 이미지 url
      this.goodsImageUrl = goodsInfo.goodsImageUrl;
      // imageNo 세팅
      this.prepaidCardOrderRequest.imageNo = goodsInfo.imageNo;

      /** 24-01-25 구매하기,선물하기 모두 카드 이미지 목록을 받아서 선택할 수 있도록 요건 변경  */
      // swiper 세팅
      // if('BUY' === this.orderType){
      //   this.card[0].id = goodsInfo.imageNo;
      //   this.card[0].cardImg = this.goodsImageUrl;
      // }

      // 최종 결제 금액
      this.goodsAmount = goodsInfo.goodsAmount.toLocaleString();

      // 할인혜택이 있는 경우에만 할인문구를 작성함
      if(goodsInfo.calcAmount){
        // 할인 문구
        this.calcAmountNotice = this.setBenefitNotice(goodsInfo.calcAmount, goodsInfo.conditionKey, goodsInfo.conditionValue);
        // 할인 금액
        this.calcAmount = goodsInfo.calcAmount.toLocaleString();
        // 혜택 금액 (최종결제금액 + 할인금액)
        this.benefitAmount = goodsInfo.benefitAmount.toLocaleString();
      }

      // 주문서 생성 요청 객체, 최종결제금액
      this.prepaidCardOrderRequest.paymentAmount = goodsInfo.goodsAmount;
      // 주문서 생성 요청 객체, 원결제금액
      this.prepaidCardOrderRequest.originalAmount = goodsInfo.conditionKey === 'FIXED_RATE_DISCOUNT' || goodsInfo.conditionKey === 'FLAT_DISCOUNT'? goodsInfo.benefitAmount : goodsInfo.goodsAmount;
      // 주문서 생성 요청 객체, 상품번호
      this.prepaidCardOrderRequest.goodsNo = goodsInfo.goodsNo;
      // 주문서 생성 요청 객체, 혜택번호
      this.prepaidCardOrderRequest.benefitNo = goodsInfo.benefitNo;

      /** 24-01-25 구매하기,선물하기 모두 카드 이미지 목록을 받아서 선택할 수 있도록 요건 변경  */
      // 카드 이미지 목록 조회
      await this.getPrepaidCardImageList();
      // 이미지 카테고리 목록 조회
      await this.getPrepaidCardImageCategory();


      // goodsAmount가 세팅되지 않았다면 에러페이지로 이동
      if(!this.goodsAmount){
        const errorPath = '/error'
        if (this.$route.path !== errorPath) {
          this.goErrorPage();
        }
        return;
      }
      // 토스페이먼츠 결제 위젯 관련
      widget = paymentWidget.renderPaymentMethods(
          '#payment-method',
          //토스 현대카드 1만원 이상 할부 가능 케이스로 1000원으로 변경
          { value: 1000 }, // 결제위젯이 처음 렌더링 될때, 위젯의 결제가격을 1만원으로 설정함으로써 할부창을 비활성화할 수 있다. 결제 버튼을 누를때 위젯의 결제가격을 상품의 가격으로 다시 세팅한다.
          { variantKey: 'noInstallment'} // 브랜드페이가 추가된 결제 UI의 variantKey(토스페이먼츠 홈페이지에서 rename or setting 가능)
      )
    },


    /**
     * 혜택 문구를 세팅하는 함수
     * @param {Number} calcAmount 할인금액
     * @param {String} conditionKey 할인 종류(discountType 참조)
     * @param {String} conditionValue 할인 값(conditionKey에 따라 할인금액 혹은 할인율)
     */
    setBenefitNotice(calcAmount, conditionKey, conditionValue){
      let calcAmountNotice = '';
      switch(conditionKey){
        case "FIXED_RATE_DISCOUNT": case "FIXED_RATE_EXTRA_CHARGE":
          calcAmountNotice = Object.fromEntries(
              Object.entries(this.discountType).map(([key, value]) => [key, conditionValue+value])
          );
          return calcAmountNotice[conditionKey];

        case "FLAT_DISCOUNT": case "FLAT_EXTRA_CHARGE":
          calcAmountNotice = Object.fromEntries(
              Object.entries(this.discountType).map(([key, value]) => [key, calcAmount+value])
        );
          return calcAmountNotice[conditionKey];

        default :
          return '';
      }
    },

    /**
     * 약관 전체 동의/해제
     */
    checkAllTerms(){
      this.isAgreeAll = !this.isAgreeAll;

      this.isOrderAgree = this.isAgreeAll;
      this.checkValidity('termsOfOrder')

      // this.isPrivateAgree = this.isAgreeAll;
      // this.checkValidity('termsOfPrivate')

      this.isAgree = this.isAgreeAll;
      this.checkValidity('termsOfUse')
    },
    /**
     * 주문 상품 동의 여부 체크시 isOrderAgree 변수의 값을 변경하는 함수
     * @param {Object} e 해당 태그의 event
     */
    checkTermsOfOrder(e){
      this.isOrderAgree = e.target.checked;
    },

    /**
     * 개인정보 수집 동의 여부 체크시 isOrderAgree 변수의 값을 변경하는 함수
     * @param {Object} e 해당 태그의 event
     */
    // checkTermsOfPrivate(e){
    //   this.isPrivateAgree = e.target.checked;
    // },

    /**
     * 이용약관 동의 여부 체크시 isAgree 변수의 값을 변경하는 함수
     * @param {Object} e 해당 태그의 event
     */
    checkTermsOfUse(e){
      this.isAgree = e.target.checked;
    },


    /**
     * input 태그의 핸드폰 번호 값을 phoneNumber 데이터에 바인딩하는 함수
     * 한글을 입력할 경우 v-model 이 제대로 작동하지 않기 때문에 v-model을 활용하지 않고 직접 바인딩
     * @param e 태그 노드의 event
     */
    phoneNumberBind(e){
      this.phoneNumber = e.target.value;
    },

    /**
     * input 태그의 구매자 이름 값을 paymentRequester 데이터에 바인딩하는 함수
     * 한글을 입력할 경우 v-model 이 제대로 작동하지 않기 때문에 v-model을 활용하지 않고 직접 바인딩
     * @param e 태그 노드의 event
     */
    nickNameBind(e){
      this.prepaidCardOrderRequest.prepaidCardNickName = e.target.value;
    },
    /**
     * 선물받는 사람의 이름을 바인딩하는 함수
     * @param e  태그의 event
     */
    receiverNameBind(e){
      this.giftRequestInfo.receiverName = e.target.value;
    },

    /**
     * 선물받는 사람의 핸드폰번호를 바인딩하는 함수
     * @param e 태그의 event
     */
    receiverPhoneNumberBind(e){
      this.giftRequestInfo.receiverPhoneNumber = e.target.value;
    },

    /**
     * 핸드폰 번호 입력란에 사용자가 번호를 입력하면
     * 자동으로 '-' 를 입력해주는 함수
     * @param e  태그의 event
     * @param {boolean} isGift 선물 여부
     */
    setDash(e, isGift){
      let inputNumber = e.target.value.replace(/[^0-9]/g, '');
      let tmp = '';
      if( inputNumber.length < 4){
        if(!isGift) this.phoneNumber =  inputNumber;
        if(isGift) this.giftRequestInfo.receiverPhoneNumber =  inputNumber;
      }else if(inputNumber.length < 7){
        tmp += inputNumber.substr(0, 3);
        tmp += '-';
        tmp += inputNumber.substr(3);
        if(!isGift) this.phoneNumber =  tmp;
        if(isGift) this.giftRequestInfo.receiverPhoneNumber =  tmp;
      }else if(inputNumber.length < 11){
        tmp += inputNumber.substr(0, 3);
        tmp += '-';
        tmp += inputNumber.substr(3, 3);
        tmp += '-';
        tmp += inputNumber.substr(6);
        if(!isGift) this.phoneNumber =  tmp;
        if(isGift) this.giftRequestInfo.receiverPhoneNumber =  tmp;
      }else{
        tmp += inputNumber.substr(0, 3);
        tmp += '-';
        tmp += inputNumber.substr(3, 4);
        tmp += '-';
        tmp += inputNumber.substr(7);
        if(!isGift) this.phoneNumber =  tmp;
        if(isGift) this.giftRequestInfo.receiverPhoneNumber =  tmp;
      }
    },

    /**
     *  상품 상세 정보를 조회 후 값을 세팅하는 함수
     */
    setGoodsDetail(){
        //상품 목록페이지로 부터 받은 param들 data 바인딩
        this.getGoodsParams();
    },

    /**
     * 결제수단 명칭을 백엔드 enum명과 동기화하는 함수
     * @param {object} selectedPaymentMethod 고객이 선택한 결제수단
     */
    enumMatching(selectedPaymentMethod) {
        switch(selectedPaymentMethod.method) {
          case '계좌이체':
            this.prepaidCardOrderRequest.payToolCode = 'ACCOUNT_TRANSFER';
            break;
          case '간편결제':
            this.prepaidCardOrderRequest.payToolCode = 'EASY_PAY';
            break;
          default:
            this.prepaidCardOrderRequest.payToolCode = 'CARD';
        }
    },
    /**
     * 결제타입 정보를 세팅하는 함수
     * @param {object} selectedPaymentMethod 고객이 선택한 결제수단
     */
    setPaymentType(selectedPaymentMethod) {
      switch(selectedPaymentMethod.type) {
        case 'BRANDPAY':
          this.prepaidCardOrderRequest.pgCode = 'brandpay';
          break;
        default:
          this.prepaidCardOrderRequest.pgCode = 'normalpay';
      }
    },

    /**
     * 주문번호 생성 api 호출을 위한 prepaidCardOrderRequest를 세팅하는 함수
     * @param {String} paymentReason 결제사유[발급(ISSUE),선물(GIFT) 등]
     * @param {Object} giftRequestInfo 선물요청정보 객체
     */
    setOrderRequest(paymentReason, giftRequestInfo) {
      if('GIFT' === paymentReason){
        this.prepaidCardOrderRequest.receiver = giftRequestInfo.receiverName;
        this.prepaidCardOrderRequest.receiverContact = giftRequestInfo.receiverPhoneNumber.replace(/[^0-9]/g, '');
        this.prepaidCardOrderRequest.giftMessage = giftRequestInfo.giftMessage;
      }

      this.prepaidCardOrderRequest.ctmmnyNo = this.$store.state.partnerId;
      this.prepaidCardOrderRequest.mberNo = this.$store.state.mberInfo.mberNo;
      this.prepaidCardOrderRequest.paymentRequesterContact = this.phoneNumber.replace(/[^0-9]/g, '');
      this.prepaidCardOrderRequest.paymentReason = paymentReason;
      this.prepaidCardOrderRequest.requestChannel = 'ONLINE';
      this.prepaidCardOrderRequest.requestId = this.$store.state.mberInfo.mberNo;


    },

    /**
     * 서버에 주문번호 생성을 요청하는 함수
     */
    setOrderIdRequestOption() {
      return {
        method: 'POST',
        url: '/api/v1.0.0/prepaid-card/order',
        data: {
          ...this.prepaidCardOrderRequest
        }
      };
    },
    /**
     * 구매하기 버튼 클릭시 결제를 진행하는 함수
     * @param {String} paymentReason  결제사유[발급(ISSUE),선물(GIFT) 등]
     * @param {Object} giftRequestInfo 선물요청정보
     */
    async clickPaymentButton(paymentReason, giftRequestInfo) {
      try{
       // 사용자가 입력한 정보들의 유효성 검증
        const isPass = this.checkValidity('ALL');

        // 유효성 검증을 통과하지 못하면 종료
        if(!isPass){
          return;
        }

        this.isButtonDisabled = true;

        // 0. 결제수단 확인 (widget에 관한 자세한 내용은 토스페이먼츠 개발자센터 참조)
        const selectedPaymentMethod = widget.getSelectedPaymentMethod()
        // 1. 결제수단 명칭을 백엔드 enum명과 동기화
        this.enumMatching(selectedPaymentMethod);
        // 2. 결제타입 정보를 세팅
        this.setPaymentType(selectedPaymentMethod);
        // 3. API 호출을 위한 prepaidCardOrderRequest 세팅
        this.setOrderRequest(paymentReason, giftRequestInfo); //ISSUE(발급)
        // 4. 서버에 주문번호(orderId) 생성 요청
        const options = this.setOrderIdRequestOption();
        const getOrderId = await axios.request(options);

        // 기간 결제금액 제한 정책 추가로 해당 부분만 분기처리, axios response 공통 수정은 영향도 이슈로 개별 처리
        if(getOrderId.status == "400" && getOrderId.code == "period.charging.amount.maximum.exceed") {
          // 기간 결제금액 제한 초과 시 메인으로 이동, 에러 데이터 메인 팝업으로 전달(메인 - showAlertPopup)
          this.$router.replace({path: '/home', query: getOrderId});
          return;
        }

        // 5. orderId 세팅
        this.orderId = getOrderId.data.data.orderNo;
        // 뒤로가기 미허용
        if(selectedPaymentMethod.type === 'NORMAL'){
          if(selectedPaymentMethod.method === '카드'){
            if(!this.isAwaradLogin()) window.location.href = "emart-today://goback/?enable=Y"
          }else{
            if(!this.isAwaradLogin())   window.location.href = "emart-today://goback/?enable=N"
          }
        }else{
          if(!this.isAwaradLogin()) window.location.href = "emart-today://goback/?enable=N"
        }

        this.isButtonDisabled = false;

        // 할부창 비활성화를 위해서 화면초기에 1만원으로 설정해둔 위젯상의 가격을 상품의 가격으로 다시 세팅
        // 다른 방법이 없었다.
        widget.updateAmount(parseInt(this.goodsAmount.replace(/\D/g,'')));

        paymentWidget.requestPayment({
          orderId: this.orderId,
          orderName: this.orderName,
          successUrl: `${process.env.VUE_APP_EMARTICON_SITE_DOMAIN}/product/order-result`, // 결제 승인에 사용되는 성공 리다이렉트 URL
          failUrl: `${process.env.VUE_APP_EMARTICON_SITE_DOMAIN}/home`,       // 결제 승인에 사용되는 실패 리다이렉트 URL
        }).then((response) => {console.log(response)})
            .catch((error)=> {
              console.log(error)
              // 할부박스 비활성화를 위해 결제 과정이 취소되면 1만원으로 설정(5만원 이상부터 할부 가능)
              // 다른 방법이 없었다.
              // 토스 현대카드 1만원 이상 할부 가능 케이스로 1000원으로 변경
              widget.updateAmount(1000);
            })


      } catch (error){
        const errorPath = '/error'
        if (this.$route.path !== errorPath) {
          this.goErrorPage();
        }
      }

    },

    /**
     * 에러페이지로 이동하는 함수
     */
    goErrorPage(){
      this.$router.push({ path: "/error" });
    },

    /**
     * 선물받는 분의 핸드폰 번호에 대한 확인 여부 값을 받는 함수
     * 확인했다면 결제를 다시 진행한다.
     * @param {boolean} confirmFlag
     */
    receiverPhoneNumberConfirm(confirmFlag){
      this.confirmReceiverPhoneNumber = confirmFlag
      this.confirmModal = false;
      // 확인여부 모달이 꺼지면 스크롤 막기 해제
      document.body.style.overflow = 'auto'
      //선물받는 분의 핸드폰 번호의 확인이 됐다면 구매과정 재실행
      if(confirmFlag){
        this.clickPaymentButton('GIFT', this.giftRequestInfo)
      }
    },

    /**
     * 구매자 번호와 선물받는 분의 핸드폰 번호가 일치함에 따라 혜택을 받을 수 없으며 이에 동의하고 구매를 진행할지 확인하는 함수
     * 확인했다면 결제를 다시 진행한다.
     * @param {boolean} confirmFlag
     */
    giftToMeConfirm(confirmFlag){
      this.confirmGiftToMe = confirmFlag
      this.giftToMeModal = false;
      // 확인여부 모달이 꺼지면 스크롤 막기 해제
      document.body.style.overflow = 'auto'
      //선물받는 분의 핸드폰 번호의 확인이 됐다면 구매과정 재실행
      if(confirmFlag){
        this.clickPaymentButton('GIFT', this.giftRequestInfo)
      }
    },

    /**
     * (선물하기) 카드 이미지 목록 조회 후 cardList(array)에 추가
     */
    async getPrepaidCardImageList() {
      try {
        const response = await apiList.getPrepaidCardImageList();
        if(response){
          response.data.data.forEach((element, index) =>{
                let obj = {}
                obj.id = element.imageNo
                obj.cardImg = element.imageUrl
                obj.imageNo = element.imageNo
                obj.categoryNo = element.categoryNo
                obj.imageDesc = element.imageDesc //웹접근성 조치
                this.cardList.push(obj)
              }
          )
        }
      } catch (error) {
        console.error(error);
        //TODO: 에러 페이지로 보내기
      }
    },
    /**
     * (선물하기) 카드 이미지 카테고리 목록 조회 후 cardList(array)에 추가
     */
    async getPrepaidCardImageCategory() {
      try {
        const response = await apiList.getPrepaidCardImageCategory();
        if(response){
          this.cardCategoryList = [...response.data.data]
          this.imageDataReady = true
        }
      } catch (error) {
        console.error(error);
        //TODO: 에러 페이지로 보내기
      }
    },
    /**
     * EmarticonCardBuy 에서 선택한 카드 이미지를 받는 함수
     * @param {String} imageNo 선택한 카드 imageUrl
     */
    selectedCardImageNo(imageNo){
      this.prepaidCardOrderRequest.imageNo = imageNo;
    },
    /**
     * 사용자가 입력한 정보들의 유효성을 검증하는 함수
     * @param {String} type 검증할 정보의 유형(카드명, 구매자명 등)
     */
    checkValidity(type){
      // 구매하기 일 때만 체크한다. (선물하기는 카드닉네임 체크 안함 24.01.22)
      if('nickName' === type || ('ALL' === type && 'BUY' === this.orderType)){
        // 카드 이름 필수
        if(this.prepaidCardOrderRequest.prepaidCardNickName.length === 0) {
          if('ALL' === type){
            this.$refs.nickName.scrollIntoView();
          }
          this.$refs.nickNameAlertBox.style.display = 'block';
          this.$refs.nickNameAlertMessage.innerHTML = '카드 이름은 필수입니다.';
          this.validationObject.nickName = false;
          return;
        }else{
          this.$refs.nickNameAlertBox.style.display = 'none';
          this.$refs.nickNameAlertMessage.innerHTML = '';
        }
        // 카드 닉네임 10자 제한
        if(this.prepaidCardOrderRequest.prepaidCardNickName.length > 10) {
          if('ALL' === type){
            this.$refs.nickName.scrollIntoView();
          }
          this.$refs.nickNameAlertBox.style.display = 'block';
          this.$refs.nickNameAlertMessage.innerHTML = '카드 이름은 최대 10자 입니다.';
          this.validationObject.nickName = false;
          return;
        }else{
          this.$refs.nickNameAlertBox.style.display = 'none';
          this.$refs.nickNameAlertMessage.innerHTML = '';
        }
        // 유효성 전체를 관리하는 Object 내의 nickName 프로퍼티 true
        this.validationObject.nickName = true;
      }

      if('phoneNumber' === type || 'ALL' === type){
        // 핸드폰 번호 입력 여부 확인
        //010-123-4567 가운데가 3자리인 경우까지 감안
        if(this.phoneNumber.length === 0){
          // 전체 체크일 경우에만 스크롤 이동
          if('ALL' === type){
            this.$refs.phoneNumber.scrollIntoView();
          }
          this.$refs.phoneNumberAlertBox.style.display = 'block';
          this.$refs.phoneNumberAlertMessage.innerHTML = '핸드폰 번호를 입력해주세요.';
          this.validationObject.phoneNumber = false;
          return;
        }else{
          this.$refs.phoneNumberAlertBox.style.display = 'none';
          this.$refs.phoneNumberAlertMessage.innerHTML = '';
        }
        if(this.phoneNumber.length <= 11){
          // 전체 체크일 경우에만 스크롤 이동
          if('ALL' === type){
            this.$refs.phoneNumber.scrollIntoView();
          }
          this.$refs.phoneNumberAlertBox.style.display = 'block';
          this.$refs.phoneNumberAlertMessage.innerHTML = '핸드폰 번호를 확인해주세요.';
          this.validationObject.phoneNumber = false;
          return;
        }else{
          this.$refs.phoneNumberAlertBox.style.display = 'none';
          this.$refs.phoneNumberAlertMessage.innerHTML = '';
        }

        // 유효성 전체를 관리하는 Object 내의 phoneNumber 프로퍼티 true
        this.validationObject.phoneNumber = true;
      }

      if ('GIFT' === this.orderType) {
        // 선물받는 분의 성함 유효성 검증
        if ('receiverName' === type || 'ALL' === type) {
          if (!this.giftRequestInfo.receiverName) {
            // 전체 체크일 경우에만 스크롤 이동
            if('ALL' === type){
              this.$refs.receiverName.scrollIntoView();
            }
            this.$refs.receiverAlertBox.style.display = 'block';
            this.$refs.receiverAlertMessage.innerHTML = '선물받는 분의 성함을 입력해주세요.';
            this.validationObject.receiverName = false;
            return;
          } else {
            this.$refs.receiverAlertBox.style.display = 'none';
            this.$refs.receiverAlertMessage.innerHTML = '';
          }

          // 유효성 전체를 관리하는 Object 내의 phoneNumber 프로퍼티 true
          this.validationObject.receiverName = true;
        }

        // 선물받는 분의 핸드폰 번호 유효성 검증
        if ('receiverPhoneNumber' === type || 'ALL' === type) {
          // 선물받는 분의 핸드폰 번호 입력 여부 확인
          if (!this.giftRequestInfo.receiverPhoneNumber) {
            // 전체 체크일 경우에만 스크롤 이동
            if('ALL' === type){
              this.$refs.receiverPhoneNumber.scrollIntoView();
            }
            this.$refs.receiverAlertBox.style.display = 'block';
            this.$refs.receiverAlertMessage.innerHTML = '선물받는 분의 핸드폰 번호를 입력해주세요.';
            this.validationObject.receiverPhoneNumber = false;
            return;
          }else{
            this.$refs.receiverAlertBox.style.display = 'none';
            this.$refs.receiverAlertMessage.innerHTML = '';
          }

          // 선물받는 분의 핸드폰 번호가 올바르게 입력되었는지 자릿수로 확인 (ex: 010-111-222 이면 체크)
          if(this.giftRequestInfo.receiverPhoneNumber.length <= 11){
            // 전체 체크일 경우에만 스크롤 이동
            if('ALL' === type){
              this.$refs.receiverPhoneNumber.scrollIntoView();
            }
            this.$refs.receiverAlertBox.style.display = 'block';
            this.$refs.receiverAlertMessage.innerHTML = '선물받는 분의 핸드폰 번호를 확인해주세요.';
            this.validationObject.receiverPhoneNumber = false;
            return;
          }else{
            this.$refs.receiverAlertBox.style.display = 'none';
            this.$refs.receiverAlertMessage.innerHTML = '';
          }

          // 유효성 전체를 관리하는 Object 내의 phoneNumber 프로퍼티 true
          this.validationObject.receiverPhoneNumber = true;
        }
      }

      // 주문 상품정보 동의 체크 확인
      if ('termsOfOrder' === type || 'ALL' === type) {
        if(!this.isOrderAgree){
          // 전체 체크일 경우에만 스크롤 이동
          if('ALL' === type){
            this.$refs.termsOfOrder.scrollIntoView();
          }
          this.$refs.termsOrderAlertBox.style.visibility = 'visible';
          this.validationObject.termsOfOrder = false;
          return;
        } else {
          this.$refs.termsOrderAlertBox.style.visibility = 'hidden';
        }

        // 유효성 전체를 관리하는 Object 내의 phoneNumber 프로퍼티 true
        this.validationObject.termsOfOrder = true;
      }

      // 개인정보 수집 동의 체크 확인
      // if ('termsOfPrivate' === type || 'ALL' === type) {
      //   if(!this.isPrivateAgree){
      //     // 전체 체크일 경우에만 스크롤 이동
      //     if('ALL' === type){
      //       this.$refs.termsOfPrivate.scrollIntoView();
      //     }
      //     this.$refs.termsPrivateAlertBox.style.visibility = 'visible';
      //     this.validationObject.termsOfPrivate = false;
      //     return;
      //   } else {
      //     this.$refs.termsPrivateAlertBox.style.visibility = 'hidden';
      //   }
      //
      //   // 유효성 전체를 관리하는 Object 내의 phoneNumber 프로퍼티 true
      //   this.validationObject.termsOfPrivate = true;
      // }

      // 서비스 이용 동의 체크 확인
      if ('termsOfUse' === type || 'ALL' === type) {
        if(!this.isAgree){
          // 전체 체크일 경우에만 스크롤 이동
          if('ALL' === type){
            this.$refs.termsOfUse.scrollIntoView();
          }
          this.$refs.termsAlertBox.style.visibility = 'visible';
          this.validationObject.termsOfUse = false;
          return;
        } else {
          this.$refs.termsAlertBox.style.visibility = 'hidden';
        }

        // 유효성 전체를 관리하는 Object 내의 phoneNumber 프로퍼티 true
        this.validationObject.termsOfUse = true;
      }

      // 구매자 번호와 선물받는 분 번호가 같으면 알림 모달 open
      if('GIFT' === this.orderType && 'ALL' === type){
        if(this.giftToMe && !this.confirmGiftToMe){
          // 구매자 번호와 선물받는 분의 번호가 동일하면 혜택을 받을 수 없는데, 결제를 진행할지 확인하는 모달 open
          this.giftToMeModal = true;
          // 확인여부 모달이 켜지면 스크롤 막기
          document.body.style.overflow = 'hidden'
          return;
        }
      }

      // '선물받는 분'의 번호가 맞는지 확인하는 모달 open
      if('GIFT' === this.orderType && 'ALL' === type){
        if(!this.confirmReceiverPhoneNumber && !this.giftToMe){
          // 핸드폰 번호 맞는지 확인여부 모달 on
          this.confirmModal = true;
          // 확인여부 모달이 켜지면 스크롤 막기
          document.body.style.overflow = 'hidden'
          return;
        }
      }



      return true;
    },

    /**
     * 카드 이미지 모달 open 여부 값을 받는 함수
     * @param {boolean} flag
     */
    useCardImageModal(flag){
      this.cardImageModal = flag
      if(flag){
        // 카드 이미지 모달이 뜨면 마우스 스크롤 막기
        document.body.style.overflow = 'hidden'
      } else {
        // 카드 이미지 모달이 뜨면 마우스 스크롤 해제
        document.body.style.overflow = 'auto'
      }
    },

    /**
     * 카테고리에서 선택된 imageNo set
     * @param {String} imageNo
     */
    selectedCategoryImageNo(imageNo){
      this.prepaidCardOrderRequest.imageNo = Number(imageNo);
      this.$refs.cardSlide.setSliderIndex(imageNo);
    },

    /**
     * 이용약관 보여주기
     */
    showAgreePopupEvent(term){
      this.showTerms = term
      this.showAgreePopup = true
    },

    /**
     * 세 가지 약관을 이용자가 직접 체크(해제)하면 "전체동의"를 체크(해제)
     */
    checkAgreeAll(){
      let agreeAll = this.isOrderAgree && this.isAgree;
      if(agreeAll){
        this.isAgreeAll = true;
      }
      if(!agreeAll){
        this.isAgreeAll = false;
      }
    },
    /**
     * 시상용 로그인 체크
     */
    isAwaradLogin() {
      if(this.$store.state.mberInfo.mberNo && this.$store.state.mberInfo.mberNo.substring(0,1) != 'C') {
        return true;
      } else {
        return false;
      }
    },
    /**
     * 한도금액설정 유의사항 문구 노출
     */
    setPrecautionsEnable() {
      const today = new Date()
      const beginDate = new Date('2026-01-26T00:00:00');

      if(today > beginDate) {
        return true;
      } else {
        return false;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/pages/products/productDetail.scss';
@import '@/assets/styles/common/termsBox.scss';

.bottom-sticky {
  position: sticky;
  bottom: 0;
}

.image-area {
  width: 100%; height: 100%;
  position: relative;
  border-radius: rem(15);
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.termsAlertMessageBox{
  font-size:14px;
  color: #C93E5F;
}

.text-box {
  width: 100%;
  padding: rem(16);
  border: 1px solid $color-gray-500;
  border-radius: rem(6);
  textarea {
    box-sizing: border-box;
    width: 100%;
    height: rem(79);
    resize: none;
    border-style: none;
    @include font-size(rem(14), rem(0), 400);
    @include font-noto-sans;
    line-height: normal;
    color: $color-primary-gray;
  }
  span {
    display: inline-block;
    width: 100%;
    @include font-size(rem(12), rem(0), 400);
    line-height: normal;
    text-align: right;
    color: $color-gray-dot;
  }
}

.alertMessageBox{
  font-size:14px;
  color: #C93E5F;
}

</style>